import React from 'react';
import { createRoot } from 'react-dom/client';
import Sculptures from '../components/Sculptures';
const projectContainer = document.getElementById('sculptures-page');

if (projectContainer) {
  const root = createRoot(projectContainer);
  root.render(
    // <React.StrictMode> // Optional, good for development
      <Sculptures />
    // </React.StrictMode>
  );
} else {
  console.error("Root element for Sculptures (#sculptures-page) not found. Check your Rails view.");
}